import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'prDuration',
    standalone: false
})
export class PrDurationPipe implements PipeTransform {
  transform(value, futur?: boolean, precise?: boolean) {
    let today = moment();
    if (futur) return this.transformInTheFutur(value, precise);
    var duration = moment.duration(today.diff(value));
    if (precise) return duration;
    return this.createOutput(duration);
  }

  transformInTheFutur(endDate, precise?: boolean) {
    const currentDate = moment();
    const endMoment = moment(endDate);

    if (moment(endDate).isBefore(moment())) {
      return 'Terminé';
    }
    var duration = moment.duration(moment(endDate).diff(moment()));
    if (precise) return duration;
    return this.createOutput(duration);
  }

  createOutput(date) {
    let output = '';
    if (date.asMonths() < 1) output = Math.floor(date.asDays()) + ' jours';
    else if (date.asYears() < 1 && date.asMonths() > 1) {
      output = Math.floor(date.asMonths()) + ' mois';
    } else {
      const years = Math.floor(date.asYears());
      const months = Math.floor(date.asMonths() % 12);
      output = `${years} an${years > 1 ? 's' : ''}`;
      if (months > 0) {
        output += ` ${months} mois`;
      }
    }
    return output;
  }

  getDiffDate(
    diff,
    type: moment.unitOfTime.DurationConstructor = 'M',
    futur: boolean = false,
  ) {
    return futur ? moment().add(diff, type) : moment().subtract(diff, type);
  }
}
